import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComprasDirectasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_CORTE_EXTERNO = process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO;
  const URL_COMPRAS_DIRECTAS = process.env.REACT_APP_URL_COMPRAS_DIRECTAS;
  const URL_ARTICULOS_ORDENES_CORTE_EXTERNO = process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE_EXTERNO;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_COMPRAS_DIRECTAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_DIRECTAS_ACUMULADOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOrdenCompra, setSelectedOrdenCompra] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [factura_proveedor, setFacturaProveedor] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [pais_origen, setPaisOrigen] = useState("Mexico");
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [total_dinero, setTotalDinero] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [impuestos, setImpuestos] = useState(false);
  const [impuestosString, setImpuestosString] = useState("No");
  const [impuestosPor, setImpuestosPor] = useState(16);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [articulosOC, setArticulosOC] = useState([]);
  const [articulosOC2, setArticulosOC2] = useState([]);
  const [fecha_orden_compra, setFechaOrdenCompra] = useState("");
  const [proveedorOrden, setProveedorOrden] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [total_kilos_orden, setTotalKilosOrden] = useState(0);
  const [total_metros_orden, setTotalMetrosOrden] = useState(0);
  const [total_piezas_orden, setTotalPiezasOrden] = useState(0);

  const [tipo, setTipo] = useState("");
  const [observacionesOrden, setObservacionesOrden] = useState("");

  const [totalCaptura, setTotalCaptura] = useState(1);
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      articulosName: "",
      colores: "",
      coloresName: "",
      tallas: "",
      tallasName: "",
      cantidad: 0,
      precio: 1,
      total: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ORDENES_CORTE_EXTERNO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOrdenesCompra = res.data;
        setOrdenesCompra(allOrdenesCompra);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

const saveCompraNueva = async (event) => {
  event.preventDefault();
  let subtotalGuarda = subtotal;
  let ivaGuarda = iva;

  if (
    fecha !== "" &&
    observaciones !== "" &&
    factura_proveedor !== "" &&
    pais_origen !== "" &&
    selectedArea !== ""
  ) {
    setValidaBoton(false);
    toggleProgreso();

    let totalRollos = inputFields.length + cantidadAgrupado.length * 2;

    try {
      const { data } = await axios.post(
        URL_COMPRAS_DIRECTAS,
        {
          fecha,
          ordenesCorteExterno: selectedOrdenCompra,
          factura_proveedor,
          observaciones,
          total_piezas,
          user: user.id,
          pais_origen,
          total_costo: total_dinero.toFixed(2),
          saldo: total_dinero.toFixed(2),
          proveedores: proveedorOrden,
          subtotal: subtotalGuarda,
          iva: ivaGuarda,
          documentado: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Guardar inventarios
      inputFields.forEach((a) => {
        if (a.articulos !== "" && a.cantidad !== 0) {
          axios
            .post(
              URL_INVENTARIOS,
              {
                articulos: a.articulos,
                colores: a.colores,
                tallas: a.tallas,
                cantidad: parseFloat(a.cantidad),
                segundas: 0,
                areas: selectedArea,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .finally(() => {
              totalRollos--;
              if (totalRollos === 0) finalizarProceso();
            });
        } else {
          totalRollos--;
          if (totalRollos === 0) finalizarProceso();
        }
      });

      // Guardar acumulados
      inputFields.forEach((w) => {
        axios
          .post(
            URL_COMPRAS_DIRECTAS_ACUMULADOS,
            {
              comprasDirectas: data._id,
              articulos: w.articulos,
              articulosOC: w.idArticulosOrden,
              colores: w.colores,
              tallas: w.tallas,
              cantidad: w.cantidad,
              ordenesCorteExterno: selectedOrdenCompra,
              fecha,
              proveedores: proveedorOrden,
              total: w.total,
              precio: w.precio,
              faltante: 0,
        // sucursales: w.idSucursales,
        areasClientes: w.idAreasClientes,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .finally(() => {
            totalRollos--;
            if (totalRollos === 0) finalizarProceso();
          });
      });

      const finalizarProceso = () => {
        axios
          .post(
            URL_LOGS,
            {
              tipo: "Crear Compra",
              detalle: `OC ${selectedOrdenCompra}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            Swal.fire("Good job!", "Creado con éxito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.error(error);
            setValidaBoton(true);
          });
      };
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.error(error);
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan datos",
    });
  }
};


const handleInputFieldChangeCantidad = (idField, idColor, idTalla, datos) => {
  const nuevaCantidad = parseFloat(datos.value) || 0;

  const nuevosInputFields = inputFields.map((i) => {
    if (
      i.id === idField &&
      String(i.colores) === String(idColor) &&
      String(i.tallas) === String(idTalla) &&
      String(i.idAreasClientes) === String(datos.idAreasClientes)
    ) {
      return {
        ...i,
        cantidad: nuevaCantidad,
        total: nuevaCantidad * parseFloat(i.precio || 0),
      };
    }
    return i;
  });

  setInputFields(nuevosInputFields);
  actualizarTotalesCon(nuevosInputFields);
};


function actualizarTotalesCon(inputArray) {
  const totalPZ = inputArray.map((c) => parseFloat(c.cantidad) || 0);
  const TP = totalPZ.reduce((t, total) => t + total, 0);
  setTotalPiezas(TP);

  const totalDin = inputArray.map((c) => parseFloat(c.total) || 0);
  const Din = totalDin.reduce((t, total) => t + total, 0);
  setSubtotal(Din);

  if (impuestos) {
    const i = Din * (impuestosPor / 100);
    setIva(i);
    setTotalDinero(Din + i);
  } else {
    setTotalDinero(Din);
    setIva(0);
  }

  const agrupado = inputArray.reduce((groups, item) => {
    const key =
      item.articulos +
      "_" +
      item.colores +
      "_" +
      item.idAreasClientes;

    if (!groups[key]) {
      groups[key] = {
        articulos: item.articulos,
        colores: item.colores,
        cantidad: 0,
        total: 0,
        id: item.id,
        unidad: item.unidad,
        articulosOrden: item.articulosOrden,
        idAreasClientes: item.idAreasClientes,
        areasClientesName: item.areasClientesName,
      };
    }

    groups[key].cantidad += Number(item.cantidad || 0);
    groups[key].total += Number(item.total || 0);
    return groups;
  }, {});

  setCantidadAgrupado(Object.values(agrupado));
}

  const calculaIVA = (e) => {
    setImpuestos(e);
    if (e == true) {
      let i = parseFloat(subtotal) * (impuestosPor / 100);
      setIva(i);
      setTotalDinero(parseFloat(subtotal) + i);
    } else {
      setTotalDinero(parseFloat(subtotal));
      setIva(0);
    }
  };

  const calculaPor = (e) => {
    setImpuestosPor(e);
    if (impuestos == true) {
      let i = parseFloat(subtotal) * (e / 100);
      setIva(i);
      setTotalDinero(parseFloat(subtotal) + i);
    } else {
      setTotalDinero(parseFloat(subtotal));
      setIva(0);
    }
  };

 
  function jalaOrden(e) {
    setSelectedOrdenCompra(e);
    setArticulosOC([]);
    setInputFields([
      {
        id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      articulosName: "",
      colores: "",
      coloresName: "",
      tallas: "",
      tallasName: "",
      cantidad: 0,
      precio: 1,
      total: 0,
      },
    ]);

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE_EXTERNO}/orden/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        const arrayArt = allArticulosOC.map((a) => {
          return {
            id: uuidv4(),
            idArticulosOrden: a._id,
            articulos: a.articulos[0]._id,
            articulosName: a.articulos[0].codigo + " - " + a.articulos[0].descripcion,
            colores: a.colores[0]._id,
            coloresName: a.colores[0].name,
            tallas: a.tallas[0]._id,
            tallasName: a.tallas[0].name + (a.tallas[0].variantesTallas?.[0]?.name
    ? " " + a.tallas[0].variantesTallas[0].name
    : ""),
            cantidad: a.cantidad,
            precio: a.precio,
            total: a.cantidad * a.precio,
            idAreasClientes: a.areasClientes[0]._id,
            areasClientesName: a.areasClientes[0].name,
            // idSucursales: a.sucursales[0]._id,
            // sucursalesName: a.sucursales[0].alias
          };
        });
        setArticulosOC(allArticulosOC);
        setInputFields(arrayArt);

        let cant = arrayArt.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TC);

        let importes = arrayArt.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setSubtotal(TG);
        setTotalDinero(TG)
      })
      .catch((err) => {
        console.log(err);
      });


    ordenesCompra.map((a) => {
      if (a._id == e) {
        setFechaOrdenCompra(a.fecha);
        setFechaCompromiso(a.fecha_compromiso);
        setProveedorOrden(a.proveedores[0]._id);
        setObservacionesOrden(a.observaciones);
      }
    });

  }
const agruparPorAreaArticulo = (inputFields) => {
  const dataAgrupada = {};

  inputFields.forEach((item) => {
    const area = item.areasClientesName || "Sin área";
    const articulo = item.articulosName || "Sin artículo";

    if (!dataAgrupada[area]) dataAgrupada[area] = {};
    if (!dataAgrupada[area][articulo]) dataAgrupada[area][articulo] = [];

    dataAgrupada[area][articulo].push({
      ...item,
      idColor: item.colores,
      idTalla: item.tallas,
      talla: item.tallasName,
      cantidad: item.cantidad,
    });
  });

  return dataAgrupada;
};

const dataAgrupada = agruparPorAreaArticulo(inputFields);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.compras_create ? (
        <div className="card container col-10">
          <Row>
            <Col md={2}>
              <Button
                size="sm"
                href="/ListadoComprasDirectas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <h3 align="center">Nueva Compra</h3>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Orden de Compra</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedOrdenCompra}
                required
                onChange={(e) => jalaOrden(e.target.value)}
              >
                <option value="0">Selecciona una Orden</option>
                {ordenesCompra
                  .sort((a, b) => (a.idOrdenesCorteExterno < b.idOrdenesCorteExterno ? 1 : -1))
                  .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.idOrdenesCorteExterno} {a.proveedores[0].razon_social}
                        </option>
                      );
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Fecha OC</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha_orden_compra}
                required
                disabled
                onChange={(e) => {
                  setFechaOrdenCompra(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Compromiso</Label>
              <Input
                type="date"
                placeholder="Fecha Compromiso"
                value={fecha_compromiso}
                required
                disabled
                onChange={(e) => {
                  setFechaCompromiso(e.target.value);
                }}
              />
            </Col>
          <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones Orden Compra
              </Label>
              <Input
                type="text"
                placeholder="ObservacionesOrden"
                value={observacionesOrden}
                disabled
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Almacen</Label>
              <Input
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                // disabled
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Factura Proveedor</Label>
              <Input
                type="text"
                placeholder="Factura Proveedor"
                value={factura_proveedor}
                required
                onChange={(e) => {
                  setFacturaProveedor(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Pais Origen</Label>
              <Input
                type="text"
                placeholder="Pais Origen"
                value={pais_origen}
                required
                onChange={(e) => {
                  setPaisOrigen(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h4 id="logoutBoton">
                TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)} pzas.
              </h4>
            </Col>
          </Row>
          <Row>
          <Col md={2}>
              <h3></h3>
              <Input
                type="checkbox"
                onChange={(event) => calculaIVA(event.currentTarget.checked)}
                checked={impuestos}
              />
              <Label className="subMenuTitulo">Costo mas IVA?</Label>
            </Col>
            {impuestos ? (
              <>
                <Col sm={2}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    IVA
                  </Label>
                  <Input
                    name="iva"
                    value={iva}
                    disabled
                  />
                </Col>
                <Col sm={2}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    % IVA
                  </Label>
                  <Input
                    name="impuestosPor"
                    value={impuestosPor}
                    onValueChange={(value) => calculaPor(value)}
                  />
                </Col>
              </>
            ) : undefined}

          </Row>

          <br />
          {/* Tabla Articulos */}
            <>
              {/* <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Talla</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row> */}


{Object.entries(dataAgrupada).map(([area, articulos]) => (
  <div key={area}>
    <h5>Área: {area}</h5>

    {Object.entries(articulos).map(([articuloNombre, combinaciones]) => (
      <div key={articuloNombre} className="ms-4 mb-3">
        <strong>{articuloNombre}</strong>

        <div className="mt-2">
          {[...new Set(combinaciones.map((c) => c.coloresName))].map(
            (colorName) => {
              const colorItem = combinaciones.find(
                (c) => c.coloresName === colorName
              );

              const colorId = colorItem?.idColor;

              const combinacionesColor = combinaciones.filter(
                (c) => c.coloresName === colorName
              );

              return (
                <div key={colorId} className="mb-3">
                  <div>
                    <strong style={{ color: "black" }}>{colorName}</strong>
                  </div>

                  <div
                    className="d-flex flex-wrap"
                    style={{ overflowX: "auto", padding: "4px 0" }}
                  >
                    {combinacionesColor
                      .sort((a, b) => {
                        const baseA = (a.talla || "").split(" ")[0];
                        const baseB = (b.talla || "").split(" ")[0];
                        const indexA = ordenTallas.indexOf(baseA);
                        const indexB = ordenTallas.indexOf(baseB);
                        return (
                          (indexA === -1 ? Infinity : indexA) -
                          (indexB === -1 ? Infinity : indexB)
                        );
                      })
                      .map((a) => (
                        <div
                          key={`${a.idTalla}_${a.idColor}_${a.idAreasClientes}`}
                          className="text-center me-3"
                          style={{ minWidth: "80px" }}
                        >
                          <Label style={{ color: "black" }}>{a.talla}</Label>
                          <Input
                            bsSize="sm"
                            type="number"
                            value={a.cantidad}
                            onChange={(event) =>
                              handleInputFieldChangeCantidad(
                                a.id,
                                a.idColor,
                                a.idTalla,
                                {
                                  value: event.target.value,
                                  idAreasClientes: a.idAreasClientes,
                                }
                              )
                            }
                            style={{ width: "60px" }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    ))}
  </div>
))}

              <Row>
                <Col md={12}>
                  <h4 id="logoutBoton">
                    TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)} pzas. 
                  </h4>
                </Col>
              </Row>

              <br />
              {validaBoton ? (
                <>
                  <Row>
                    <Button
                      type="submit"
                      className="btn btn-success"
                      onClick={saveCompraNueva}
                    >
                      Guardar
                    </Button>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                    <Button
                      href="/ListadoComprasDirectas"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Row>
                </>
              )}
              <br />
            </>


          {/* Termina Tabla Articulos */}

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasDirectasCreate;
